export default "__VITE_ASSET__8a33e079__"